module.exports = __webpack_public_path__ + "static/media/pristine-609.a2050abb.mp3";